import React from "react";
import { IconX } from "@tabler/icons-react";

interface Props {
  name: string;
  onClose: () => void;
}

const ZoneHeader: React.FC<Props> = ({ name, onClose }) => (
  <div className="flex items-start justify-between mb-1 md:mb-4">
    <h2 className="text-base md:text-xl font-bold text-gray-700 tracking-tight">{name}</h2>
    <button
      onClick={onClose}
      className="p-1 rounded-full hover:bg-gray-100 transition-colors hidden md:inline"
    >
      <IconX size={22} className="text-gray-500" />
    </button>
  </div>
);

export default ZoneHeader;
